import React from 'react';
import InternalSpinner from '../spinner/internal';
import styles from './styles.css.js';
export default (function (props) { return (React.createElement("div", { className: styles['loading-screen'] },
    React.createElement(InternalSpinner, null),
    "\u00A0",
    props.children)); });
//# sourceMappingURL=loading-screen.js.map